import React from 'react';

import * as util from 'biojs/Util';
import notifications from 'notifications';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {InputChangeEvent} from 'util/Types';

import {AssemblySlotType} from './AssemblyModels';

interface Props {
  slot: AssemblySlotType;
}

interface State {
  name: string;
  bases: string;
}

class SpacerEditor extends React.Component<Props, State> {
  stateFromProps = (props: Props): State => ({
    name: props.slot.name()!,
    bases: props.slot.spacer()!,
  });

  UNSAFE_componentWillReceiveProps(nextProps: Props): void {
    if (nextProps.slot !== this.props.slot) {
      this.setState(this.stateFromProps(nextProps));
    }
  }

  updateName = (e: InputChangeEvent): void => {
    const name = e.target.value.trimLeft();
    this.setState({name});
  };

  updateBases = (e: InputChangeEvent): void => {
    const bases = util.sanitize(e.target.value, util.NucleotideType.DNA);
    this.setState({bases});
  };

  saveChanges = (e: React.FormEvent): void => {
    e.preventDefault();
    this.props.slot
      .set({name: this.state.name, spacer: this.state.bases})
      .save(null, {patch: true})
      .fail(notifications.notifyError)
      .done(() => {
        notifications.success('Spacer successfully updated.');
      });
    // Need to force update because slot object doesn't change and save button should get disabled.
    this.forceUpdate();
  };

  changesMade = (): boolean =>
    this.state.name !== this.props.slot.name() || this.state.bases !== this.props.slot.spacer();

  state: State = this.stateFromProps(this.props);

  render(): JSX.Element {
    const disableSave = !this.changesMade();
    return (
      <form className="form-inline u-spacing-top" onSubmit={this.saveChanges}>
        <input
          type="text"
          placeholder="Name"
          value={this.state.name}
          onChange={this.updateName}
          className="u-inline-form-input"
        />{' '}
        <input
          type="text"
          placeholder="Bases"
          value={this.state.bases}
          onChange={this.updateBases}
          className="u-inline-form-input-lg"
        />{' '}
        <Button
          buttonStyle={ButtonStyle.PRIMARY}
          size={ButtonSize.SMALL}
          type="submit"
          disabled={disableSave}
          text="Save"
        />
      </form>
    );
  }
}

export default SpacerEditor;
